/** @format */

import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectCommonState = createFeatureSelector<any>('common');

export const selectPageType = createSelector(selectCommonState, (state) => state.pageType);
